<template>
  <div>
    <h3 class="mb-5">Filter</h3>
    <div class="h4 my-5">
      Filter會顯示於Product SubCategory Page ;
      同SubCategory的產品將同步Filter種類
    </div>
    <!-- add -->
    <div class="d-flex pa-5 brand-100">
      <div class="d-flex my-n2 flex-grow-1">
        <div class="ml-auto">
          <filterDialog @add-filter="addItem"></filterDialog>
        </div>
      </div>
    </div>

    <!-- items -->
    <!--<div-->
      <!--class="form-item d-flex px-5 py-3"-->
    <!--&gt;-->
      <!--<div class="d-flex flex-grow-1 align-center">-->
        <!--<h4 class="mr-1 w-230px">-->
          <!--<span>子分類</span>-->
          <!--<span>(SubCategory)</span-->
          <!--&gt;-->
        <!--</h4>-->
        <!--<v-checkbox v-model="subcategory.is_filter"></v-checkbox>-->
      <!--</div>-->
      <!--<div class="ml-5"></div>-->
    <!--</div>-->
    <!-- items -->
    <div
      class="form-item d-flex px-5 py-3"
      v-for="(item, i) in subcategory.specs"
      :key="i"
    >
      <div class="d-flex flex-grow-1 align-center">
        <h4 class="mr-1 w-230px">
          <span>{{ item.title }}</span>
          <span v-if="item.is_customized == true">
            (Customized)
          </span>
        </h4>
        <v-checkbox v-model="item.is_filter"></v-checkbox>
      </div>
      <div class="ml-5">
        <button
          class="btn square mr-10px"
          @click="editItem(item)"
          v-if="item.is_customized == true"
        >
          <v-icon>edit</v-icon>
        </button>
        <button
          class="btn square mr-10px"
          @click="deleteItem(item)"
          v-if="item.is_customized == true"
        >
          <v-icon>delete</v-icon>
        </button>
        <button class="btn square mr-10px" @click="downItem(item, i)">
          <v-icon>arrow_downward</v-icon>
        </button>
        <button class="btn square" @click="upItem(item, i)">
          <v-icon>arrow_upward</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import filterDialog from '@/views/C-2__SubCategory/c/C-2-2-2-1__SubCategory_DialogCustomized-Filter-Create.vue';

export default {
  components: {
    filterDialog,
  },
  data: () => ({
    isOpen: false,
    filterData: {},
  }),
  computed: {
    ...mapState('subcategory', [
      'subcategory',
    ]),
  },
  methods: {
    ...mapActions('subcategory', {
      setFilterData: 'setFilterData',
      toggleFilterDialog: 'toggleFilterDialog',
    }),
    addItem(item) {
      const template = {
        id: null,
        is_customized: true,
        title: item.title,
        options: item.options,
      };

      this.subcategory.specs.push(template);
    },
    editItem(item) {
      this.setFilterData(item);
      this.toggleFilterDialog(true);
    },
    deleteItem(item) {
      const index = this.subcategory.specs.map((option) => option.id).indexOf(item.id);
      this.subcategory.specs.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.subcategory.specs.length - 1) {
        this.subcategory.specs.splice(i, 1);
        this.subcategory.specs.unshift(item);
        return;
      }
      // item become next index
      this.subcategory.specs.splice(i, 1);
      this.subcategory.specs.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.subcategory.specs.splice(i, 1);
        this.subcategory.specs.push(item);
        return;
      }
      // item become previous index
      this.subcategory.specs.splice(i, 1);
      this.subcategory.specs.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
